import {
  type FixedTermOption,
  FixedTermPage,
  getFixedTermOptions,
  LoadingPage,
} from '@resurs-internal/deposits-app-components';
import { useContext } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router';

import { CountryContext } from '@/contexts';
import { getSectionCount, hasFixedTermView, isAuthenticated } from '@/helpers';
import { useCampaignCode, useProducts } from '@/hooks';
import { authenticateUser } from '@/services';
import { InterestRateType } from '@/types/consumer-deposit-application-service';

export const FixedTermView = () => {
  const { country } = useContext(CountryContext);
  const navigate = useNavigate();
  const { productCode } = useParams();
  const { appendCampaignCode } = useCampaignCode();
  const { isLoading, productFromCode } = useProducts(country);

  const applicationPath = (selected: FixedTermOption) =>
    appendCampaignCode(
      '/application',
      new URLSearchParams({
        configurationRuleId: selected.configurationRuleId,
      }),
    );

  if (isLoading) return <LoadingPage country={country} />;

  const product = productCode ? productFromCode(productCode) : undefined;
  const options = product ? getFixedTermOptions(product) : [];

  if (!product || !hasFixedTermView(product) || !options.length) {
    return <Navigate replace to={appendCampaignCode('/choose-account-type')} />;
  }

  return (
    <FixedTermPage
      authenticateUser={(selected) =>
        authenticateUser(applicationPath(selected), product.code, country)
      }
      country={country}
      isAuthenticated={isAuthenticated()}
      navigateBack={() =>
        navigate(
          appendCampaignCode(
            `/choose-account-type/${encodeURIComponent(product.code)}`,
          ),
        )
      }
      navigateForward={(selected) => {
        const params = new URLSearchParams({
          configurationRuleId: selected.configurationRuleId,
          state: product.code,
        });

        navigate(appendCampaignCode('/application', params));
      }}
      options={options}
      section={1}
      totalSections={getSectionCount(country, InterestRateType.FIXED, true)}
    />
  );
};
